import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { Button, Navbar, Nav, NavDropDown, Container, Col, Row, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faLinkedin, faGithub} from '@fortawesome/free-brands-svg-icons'
import Image from "./image"
import './header.css'

const IconLink = (props) => {
    return (
        <a {...props} style={{color: 'white', marginLeft: '0.5rem', marginRight: '0.5rem'}}>
              <FontAwesomeIcon style={{fontSize: 'xx-large'}} icon={props.icon} />
          </a>
    )
}

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {expanded: false};
    }
    render() {
        const { siteTitle } = this.props
        const { expanded } = this.state
        const collapse = ()=>{
            this.setState({expanded:false})
        }
        return (
  <header
      className="my-header"
  >
      <Navbar collapseOnSelect expanded={expanded} className="header-navbar cloud-sky" expand="lg">
          <Navbar.Brand style={{display: 'flex', }} >
              <Image style={{width: '2.0rem'}}filename="ProfilePhoto"/>
              <IconLink href="https://www.facebook.com/zeng.dai" icon={faLinkedin} />
              <IconLink href="https://www.linkedin.com/in/zeng-dai-3950a245/" icon={faFacebook} />
              <IconLink href="https://github.com/daizeng1984" icon={faGithub} />
          </Navbar.Brand>
          <Navbar.Toggle style={{fontSize: 'small', }} aria-controls="basic-navbar-nav" onClick={()=>{this.setState({expanded: !this.state.expanded})}} />
          <Navbar.Collapse id="basic-navbar-nav" onClick={collapse} onTouchMove={collapse}>
              <Nav className="mr-auto">
                  <Link className="header-navbar-link" to="/" icon="home" >
                      <Button className="header-navbar-button" size="lg" >
                          Home
                      </Button>
                  </Link>
                  <Link className="header-navbar-link" to="/project" icon="info" >
                      <Button className="header-navbar-button" size="lg">
                          Project
                      </Button>
                  </Link>
                  <Link className="header-navbar-link" to="/blog" icon="info" >
                      <Button className="header-navbar-button" size="lg">
                          Blog
                      </Button>
                  </Link>
                  <Link className="header-navbar-link" to="/about" icon="info" >
                      <Button className="header-navbar-button" size="lg">
                          About
                      </Button>
                  </Link>
                  
                  
                  {/* <Nav.Link href="#home">Home</Nav.Link> */}
                  {/* <Nav.Link href="#a">Link</Nav.Link> */}
                  {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown"> */}
                  {/*     <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item> */}
                  {/*     <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item> */}
                  {/*     <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item> */}
                  {/*     <NavDropdown.Divider /> */}
                  {/*     <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item> */}
                  {/* </NavDropdown> */}
              </Nav>
              {/* <Form inline> */}
              {/*     <FormControl type="text" placeholder="Search" className="mr-sm-2" /> */}
              {/*     <Button variant="outline-success">Search</Button> */}
              {/* </Form> */}
          </Navbar.Collapse>
      </Navbar>

  </header>
)
    }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
